/**
 * Feature Flags Configuration
 * 
 * Controls V2 features that can be enabled/disabled via environment variables.
 * All V2 features default to disabled for production safety.
 */

export const FEATURES = {
  // V2 Features - disabled by default
  V2_ENABLE_CASE_ARCHIVE: process.env.REACT_APP_V2_ENABLE_CASE_ARCHIVE === 'true',
  V2_ENABLE_ADMIN_PORTAL: process.env.REACT_APP_V2_ENABLE_ADMIN_PORTAL === 'true',
  V2_ENABLE_SYSTEM_CHECK: process.env.REACT_APP_V2_ENABLE_SYSTEM_CHECK === 'true',
  
  // Analytics - disabled by default until configured
  ENABLE_META_PIXEL: !!process.env.REACT_APP_META_PIXEL_ID,
  ENABLE_GA4: !!process.env.REACT_APP_GA4_MEASUREMENT_ID,
};

/**
 * Check if a feature is enabled
 * @param {string} featureName - The feature flag name
 * @returns {boolean}
 */
export const isFeatureEnabled = (featureName) => {
  return FEATURES[featureName] === true;
};

export default FEATURES;
